












































































import {myVue} from "@/components/class/myVue";
import {Component} from 'vue-property-decorator';
import * as utils from "@/components/util/utils";

@Component
export default class HelloWorld extends myVue {
    data() {
        return {
            formInline: {
                formInlineList: [
                    {
                        index: 1,
                        formInlineVal: "",
                        label: "优惠券名称:",
                        placeHolder: "请输入优惠券名称",
                        rules: {
                            formInlineVal: [
                                {required: true, message: "请输入优惠券名称", trigger: "blur"}
                            ]
                        }
                    },
                    {
                        index: 2,
                        formInlineVal: "",
                        label: "消费限制:",
                        placeHolder: "消费满XX元可用，不填表示不限",
                        rules: {
                            formInlineVal: [{required: false}]
                        }
                    },
                    {
                        index: 2,
                        formInlineVal: "",
                        label: "消费限制:",
                        placeHolder: "消费满XX元可用，不填表示不限",
                        rules: {
                            formInlineVal: [{required: false}]
                        }
                    },
                    {
                        index: 2,
                        formInlineVal: "",
                        label: "消费限制:",
                        placeHolder: "消费满XX元可用，不填表示不限",
                        rules: {
                            formInlineVal: [{required: false}]
                        }
                    }
                ]
            },

        }
    }

    add() {
        this.current.add()
    }

    reIndex(edit_index: any) {
        let newValue: any[] = JSON.parse(this.current.valueFormat())
        if (utils.isNull(newValue)) {
            newValue = utils.lodash.cloneDeep(this.current.value)
        }
        utils.lodash.pullAt(newValue, edit_index);
        this.current.value = newValue
    }
}
